import React, { useContext, useEffect, useState } from "react";
import ContentLayout from "../../component/ContentLayout";
import { Context } from "../../component/Context/ErrorContext";
import moment from "moment/moment";
import axios from "../../util/axios";

const Rewards = () => {
  const { setError } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [rewardsDetail, setRewardsDetail] = useState<any>([]);
  const [selectedFilterType, setSelectedFilterType] = useState("date");

  const getRewardData = () => {
    setLoading(true);
    const sort_by = selectedFilterType === "date" ? "asc" : "desc";
    axios({
      URL: `/omw/get-reward?sort_order=${sort_by}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data?.rewards;
        setRewardsDetail(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (selectedFilterType) {
      getRewardData();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilterType]);

  return (
    <ContentLayout className={"items-start"}>
      <div className="bg-white w-full">
        <div className="w-full mt-4 flex justify-between px-8 flex-wrap">
          <p className={"text-3xl font-bold text-secondary underline"}>
            Rewards
          </p>
          <div className="relative inline-block text-left">
            <select
              className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
              onChange={(e) => setSelectedFilterType(e.target.value)}
            >
              <option value="date">Date</option>
              <option value="alphabetical">Alphabetical</option>
              <option value="popularity">Popularity</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg
                className="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M5.516 7.548L10 12.032l4.484-4.484L16.017 8 10 14.018 3.983 8z" />
              </svg>
            </div>
          </div>
        </div>
        <div className="m-8">
          <div className="container p-4 mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
              {rewardsDetail?.map((card: any, index: number) => {
                return (
                  <div
                    className="w-full max-w-sm sm:max-w-full md:max-w-sm rounded-lg overflow-hidden shadow-lg bg-white border border-gray-200"
                    key={`reward_${index + 1}`}
                  >
                    <div className="relative">
                      <img
                        className="w-full h-40 object-cover rounded-t-lg"
                        src={card?.claim_image}
                        alt={card?.claim_name}
                      />
                      {/*<div className={"w-full h-40 rounded-t-lg"} />*/}
                      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
                        <div className="text-lg text-white font-bold mb-2">
                          {card?.claim_name}
                        </div>
                        <hr className="border-t-2 border-white my-2" />
                        <div className="flex justify-center items-center">
                          <p className="text-sm text-white">
                            {card?.claim_description}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="px-4 py-3">
                      <div className="bg-blue-50 rounded-lg p-3 mb-3 shadow-sm">
                        <div className="font-semibold text-blue-600">
                          {card.male_percentage > card.female_percentage
                            ? "Male"
                            : card?.unspecified_percentage >
                                card.male_percentage ||
                              card?.unspecified_percentage >
                                card.female_percentage
                            ? "Unspecified"
                            : "Female"}{" "}
                          (%):
                        </div>
                        <div className="text-lg font-bold">
                          {Math.round(
                            (card.male_percentage > card.female_percentage
                              ? card?.male_percentage
                              : card?.unspecified_percentage >
                                  card.male_percentage ||
                                card?.unspecified_percentage >
                                  card.female_percentage
                              ? card?.unspecified_percentage
                              : card?.female_percentage) * 100
                          ) / 100}
                          %
                        </div>
                      </div>
                      <div className="bg-blue-50 rounded-lg p-3 shadow-sm">
                        <div className="font-semibold text-blue-600">
                          Created:
                        </div>
                        <div className="text-lg">
                          {moment(card.created_dt).format("MM-DD-YYYY")}
                        </div>
                      </div>
                    </div>
                    {/*<div className="px-4 py-3">*/}
                    {/*  /!*<div className="flex items-center text-lg mb-2">*!/*/}
                    {/*  /!*  <div className="font-semibold text-blue-600">*!/*/}
                    {/*  /!*    Total Redemptions:*!/*/}
                    {/*  /!*  </div>*!/*/}
                    {/*  /!*  <div className="ml-2">{card.totalRedemptions}</div>*!/*/}
                    {/*  /!*</div>*!/*/}
                    {/*  <div className="flex items-center text-lg mb-2">*/}
                    {/*    <div className="font-semibold text-blue-600">*/}
                    {/*      {card.male_percentage > card.female_percentage*/}
                    {/*        ? "Male"*/}
                    {/*        : "Female"}{" "}*/}
                    {/*      (%):*/}
                    {/*    </div>*/}
                    {/*    <div className="ml-2">*/}
                    {/*      {Math.round(*/}
                    {/*        card.male_percentage > card.female_percentage*/}
                    {/*          ? card?.male_percentage*/}
                    {/*          : card?.female_percentage * 100,*/}
                    {/*      ) / 100}*/}
                    {/*      %*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*  <div className="flex items-center text-lg">*/}
                    {/*    <div className="font-semibold text-blue-600">*/}
                    {/*      Created:*/}
                    {/*    </div>*/}
                    {/*    <div className="ml-2">*/}
                    {/*      {moment(card.created_dt).format("MM-DD-YYYY")}*/}
                    {/*    </div>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </ContentLayout>
  );
};

export default Rewards;
